import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
  Button,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DialogActions from "@mui/material/DialogActions";
import AlertBar from "./AlertBar";
import { API_URL } from "../../config/environment";
import {
  refreshIngredients,
  refreshIngredientsMetrics,
} from "../../helpers/refreshData";
import { useTranslation } from "react-i18next";

const SingleDeleteIngredients = ({ open, onClose, id }) => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const token = sessionStorage.getItem("authToken");

  async function handleDelete() {
    const url = `${API_URL}/ingredients/${id}`;
    console.log({ id });

    try {
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 403) {
        setErrors(true);
        return setErrorMessage("You are not permitted to update ingredients");
      }

      const data = await response.json();
      if (data.status === "success") {
        setSuccess(true);
        setSuccessMessage("Ingredients deleted successfully");
        refreshIngredients();
        refreshIngredientsMetrics();
      } else {
        setErrors(true);
        setErrorMessage(data.message);
      }
    } catch (error) {
      setErrors(true);
      console.log(error);
      setErrorMessage(error?.message);
    } finally {
      onClose();
    }
  }

  function handleOnClose() {
    onClose();
  }

  const dialogStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: "blur(5px)",
  };

  const closeButtonStyle = {
    position: "absolute",
    top: 0,
    right: 0,
    margin: "16px", // Add margin as needed
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        style={dialogStyle}
        maxWidth="xl"
        fullWidth={true}
      >
        {/* Close button */}
        <IconButton
          edge="end"
          color="inherit"
          onClick={handleOnClose}
          style={closeButtonStyle}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle>
          <Typography variant="h5" gutterBottom fontWeight={700}>
            {t("dashboard.ingredientDetails.ingredientsDelete.heading")}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="h6" gutterBottom fontWeight={300} fontSize={14}>
            {t("dashboard.ingredientDetails.ingredientsDelete.desc")}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="success"
            component="span"
            onClick={onClose}
          >
            {t("dashboard.ingredientDetails.noBtn")}
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleDelete}
            sx={{ margin: "20px" }}
          >
            {t("dashboard.ingredientDetails.yesBtn")}
            {isloading && <CircularProgress size={20} color="inherit" />}
          </Button>
        </DialogActions>
      </Dialog>

      <AlertBar
        open={errors}
        message={errorMessage}
        severity={"error"}
        onClose={() => setErrors(false)}
      />

      <AlertBar
        open={success}
        message={successMessage}
        severity={"success"}
        onClose={() => setSuccess(false)}
      />
    </>
  );
};

export default SingleDeleteIngredients;
